import Repository from "./Repository";

const resources = "/resources";

export default {
  getResources: (params) => Repository.get(`${resources}/`, { params: params }),
  updateDescription: (id, payload) =>
    Repository.patch(`${resources}/${id}/update_description/`, payload),
};
